export default "__VITE_PUBLIC_ASSET__4b5c6317__"